import React from 'react';
import { RecordingsList } from '../components/RecordingsList';

export const RecordingsPage: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <div className="container mx-auto p-6 animate-fadeIn">
      <div className="mb-6">
        <h1 className="text-2xl font-bold mb-2">My Recordings</h1>
        <p className="text-white/70 max-w-2xl">View, manage, and share your recorded performances. You can play, download, share, or score your recordings at any time.</p>
      </div>

      <div className="card relative overflow-hidden">
        <div className="absolute top-0 right-0 left-0 h-1 bg-gradient-to-r from-kod-accent via-purple-500 to-blue-500 opacity-70"></div>
        
        <div className="flex justify-between items-center mb-6">
          <h2 className="font-semibold text-lg">Your Performances</h2>
          <button 
            onClick={() => navigate('/sing')}
            className="px-4 py-2 bg-kod-accent hover:bg-kod-accent-dark text-white rounded-lg flex items-center transition-colors"
          >
            <Mic size={18} className="mr-2" />
            Record New Song
          </button>
        </div>
        
        <RecordingsList
          onPlay={() => {}}
        />
      </div>
    </div>
  );
};

import { Mic } from 'lucide-react';
import { useNavigate } from 'react-router-dom';